<template lang="pug">
.card
  .card-header.d-flex.p-0
    ul.nav.nav-pills.mr-auto.p-2.text-sm
      li.nav-item(v-if="report_type == 'popup'")
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'popup' }", @click="setTabActive('popup')", tabindex="1") ポップアップ
      li.nav-item(v-if="report_type == 'popup'")
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'new_overlay_image' }", @click="setTabActive('new_overlay_image')", tabindex="2") オーバーレイ
      li.nav-item(v-if="is_new_ui")
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'scenario' }", @click="setTabActive('scenario')", tabindex="3") シナリオポップアップ
      li.nav-item
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'creative' }", @click="setTabActive('creative')", tabindex="4") クリエイティブ
      li.border-left.mx-2
      li.nav-item
        a.nav-link(:class="{ active: $store.state.report.selected_cond_tab == 'leave_pre' }", @click="setCondTabActive('leave_pre')", tabindex="4") 離脱
      li.nav-item
        a.nav-link(:class="{ active: $store.state.report.selected_cond_tab == 'specific_position' }", @click="setCondTabActive('specific_position')", tabindex="5") 特定条件
      li.nav-item
        a.nav-link(:class="{ active: $store.state.report.selected_cond_tab == 'normal' }", @click="setCondTabActive('normal')", tabindex="6") 常時
      li.border-left.mx-2
      li.nav-item
        a.nav-link(:class="{ active: $store.state.report.selected_display_tab == 'on' }", @click="setDisplayTabActive('on')", tabindex="7") 表示中
      li.nav-item
        a.nav-link(:class="{ active: $store.state.report.selected_display_tab == 'off' }", @click="setDisplayTabActive('off')", tabindex="8") 停止中
    pagination.p-2(
      v-model="currentPage"
      :per-page="10"
      :records="$store.state.report.total_records"
      edgeNavigation=true
      @paginate="setClickedPage"
    )
  .card-body.p-0
    template(v-if="$store.state.report.selected_new_overlay_name")
      .pt-3.pl-3.pb-0
        | 選択中&nbsp;:&nbsp;
        span.tag
          i.fa.fa-times(@click="clearNewOverlay($event)")
          | {{$store.state.report.selected_new_overlay_name}}
    template(v-if="$store.state.report.selected_popup_name")
      .pt-3.pl-3.pb-0
        | 選択中&nbsp;:&nbsp;
        span.tag
          i.fa.fa-times(@click="clearPopup($event)")
          | {{$store.state.report.selected_popup_name}}
    .p-3
      form.form-inline
        .form-group
          label 日付&nbsp;:&nbsp;
        .form-group.mr-3
          select.form-control(@change="dateSelectChange")
            option(v-for='date in $store.state.report.date_for_select',:value="date.k",:key="date.k")
              | {{date.v}}
        .form-group
          vuejs-datepicker(:format="DatePickerFormat",:language="language", :value="$store.state.report.date_from", @selected="selectDateFrom", input-class="form-control")
        .form-group &nbsp;~&nbsp;
        .form-group
          vuejs-datepicker(:format="DatePickerFormat",:language="language", :value="$store.state.report.date_to", @selected="selectDateTo", input-class="form-control")
        report-col
        template(v-if="['popup', 'creative', 'new_overlay_image'].includes($store.state.report.selected_tab) && $store.state.report.report_type != 'scenario'")
          i.fas.fa-lg.fa-download(title="レポートダウンロード" style="cursor: pointer; padding-left: 10px;" @click="downloadReport()")
    .tab-content
      .tab-pane(:class="{ active: $store.state.report.selected_tab == 'new_overlay_image' }")
        table.table.table-bordered.not-creative
          thead
            tr
              th.sort_col(v-for="name in display_col_names")
                template(v-if="!isSortable(name)") {{translateName(name)}}
                template(v-else)
                  template(v-if="ascSorted(name)")
                    span.pointer(@click="sortDescNewOverlayReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up.active
                    i.fas.fa-sort-down
                  template(v-else-if="descSorted(name)")
                    span.pointer(@click="sortAscNewOverlayReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down.active
                  template(v-else)
                    span.pointer(@click="sortDescNewOverlayReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down
                help-tooltip(v-if="reportColHelpKey(name)" :html-key="reportColHelpKey(name)")
          tbody
            tr(v-for="row in $store.state.report.new_overlay_reports")
              td(v-for="name in display_col_names")
                template(v-if='name == "overlay_name"')
                  a(href="#",@click="selectNewOverlay(row[name], $event)") {{row[name]}}
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    | {{modifyNumberFormat(name, row[name])}}
      .tab-pane(:class="{ active: $store.state.report.selected_tab == 'popup' || $store.state.report.selected_tab == 'scenario' }")
        table.table.table-bordered.not-creative
          thead
            tr
              th.sort_col(v-for="name in display_col_names")
                template(v-if="!isSortable(name)") {{translateName(name)}}
                template(v-else)
                  template(v-if="ascSorted(name)")
                    span.pointer(@click="sortDescPopupReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up.active
                    i.fas.fa-sort-down
                  template(v-else-if="descSorted(name)")
                    span.pointer(@click="sortAscPopupReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down.active
                  template(v-else)
                    span.pointer(@click="sortDescPopupReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down
                help-tooltip(v-if="reportColHelpKey(name)" :html-key="reportColHelpKey(name)")
          tbody
            tr(v-for="row in $store.state.report.popup_reports")
              td(v-for="name in display_col_names")
                template(v-if="name == 'popup_name'")
                  a(href="#", @click="selectPopup(row[name], $event)") {{ row[name] }}
                template(v-else-if="isHiddenByIframe(name, row)")
                  | --
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    | {{ modifyNumberFormat(name, row[name]) }}
      .tab-pane(:class="{ active: $store.state.report.selected_tab == 'creative' }")
        table.table.table-bordered
          thead
            tr
              th.sort_col(v-for="name in display_col_names")
                template(v-if="!isSortable(name)") {{translateName(name)}}
                template(v-else)
                  template(v-if="ascSorted(name)")
                    span.pointer(@click="sortDescCreativeReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up.active
                    i.fas.fa-sort-down
                  template(v-else-if="descSorted(name)")
                    span.pointer(@click="sortAscCreativeReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down.active
                  template(v-else)
                    span.pointer(@click="sortDescCreativeReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down
                help-tooltip(v-if="reportColHelpKey(name)" :html-key="reportColHelpKey(name)")
          tbody
            tr(v-for="row in $store.state.report.creative_reports")
              td(v-for="name in display_col_names",:class="{ title_wrapper: name=='title' }")
                template(v-if='name == "image"')
                  img(:src='row[name]',width="100px")
                template(v-else-if='name == "display"')
                  toggle-button(
                    :value="row['limited_time'] ? row['limited_time_range_now'] : row[name]",
                    :labels="true",
                    @change="switchCreative($event, row)", :sync="true"
                  )
                template(v-else-if="name == 'popup_name' && row['is_scenario'] == true")
                  a(href="#", @click="selectScenarioCreative(row['id'], $event)") {{ row[name] }}
                template(v-else-if="isHiddenByIframe(name, row)")
                  | --
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    span(v-html="modifyNumberFormat(name, row[name])")
      .tab-pane(:class="{ active: $store.state.report.selected_tab == 'scenario_creative' }")
        scenario-popup-report


</template>

<script>
import Vue from 'vue';

import vuejsDatepicker from 'vuejs-datepicker';

//components
import ReportCol from '../components/reports/cols.vue';
import ScenarioPopupReport from '../components/scenario_popup_report.vue'
//mixins
import DateformatMixin from '../mixins/date_format.js';

export default {
  props: {
    date_from: String,
    date_to: String,
    date_yesterday_start: String,
    date_yesterday_end: String,
    date_month_start: String,
    date_last_month_start: String,
    date_last_month_end: String,
    report_type: {type: String, default: "widget"},
    is_new_ui: { type: Boolean, default: false }
  },
  data(){
    return {
      DatePickerFormat: 'yyyy-MM-dd',
      language:{
        language: 'Japanese',
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['日', '月', '火', '水', '木', '金', '土'],
        rtl: false,
        ymd: 'yyyy-MM-dd',
        yearSuffix: '年'
      },
      currentPage: 1,
      initialized: false,
    }
  },
  mixins: [DateformatMixin],
  methods: {
    setClickedPage() {
      this.$store.commit("report/setCurrentPage", this.currentPage);
    },
    setTabActive(name) {
      this.currentPage = 1;
      this.$store.commit("report/setCurrentPage", this.currentPage);
      if (name !== 'creative') {
        this.$store.commit("report/changeReportType", name);
      }
      this.$store.commit("report/setSelectedTab", name);
      location.hash = name;
      this.$store.commit('report/updateDefaultCols', name);
    },
    setCondTabActive(name) {
      if(this.$store.state.report.selected_cond_tab == name){
        this.$store.commit("report/setSelectedCondTab", '');
      } else {
        this.$store.commit("report/setSelectedCondTab", name);
      }
    },
    setDisplayTabActive(name) {
      if(this.$store.state.report.selected_display_tab == name){
        this.$store.commit("report/setSelectedDisplayTab", '');
      } else {
        this.$store.commit("report/setSelectedDisplayTab", name);
      }
    },
    getWidgetReport(){
      this.$store.dispatch("report/getWidget")
    },
    getPopUpReport(){
      this.$store.dispatch("report/getPopUp")
    },
    getAreaPopUpReport(){
      this.$store.dispatch("report/getAreaPopUp")
    },
    getOverlayImageReport(){
      this.$store.dispatch("report/getOverlayImage")
    },
    getPopupReport(){
      this.$store.dispatch("report/getPopup")
    },
    getNewOverlayImageReport(){
      this.$store.dispatch("report/getNewOverlayImage")
    },
    getCreativeReport(){
      this.$store.dispatch("report/getCreative")
    },
    getScenarioReport(){
      this.$store.dispatch("report/getScenario");
    },
    getScenarioCreativeReport(){
      this.$store.dispatch("report/getScenarioCreative");
    },
    getReport(resetSort = true){
      if (!this.initialized) return;

      if(this.$store.state.report.selected_tab=='widget'){
        this.getWidgetReport()
      } else if(this.$store.state.report.selected_tab=='overlay_image'){
        this.getOverlayImageReport()
      } else if(this.$store.state.report.selected_tab=='pop_up'){
        this.getPopUpReport()
      } else if(this.$store.state.report.selected_tab=='area_pop_up'){
        this.getAreaPopUpReport()
      } else if(this.$store.state.report.selected_tab=='popup'){
        this.getPopupReport()
      } else if(this.$store.state.report.selected_tab=='new_overlay_image'){
        this.getNewOverlayImageReport()
      } else if(this.$store.state.report.selected_tab=='creative') {
        this.getCreativeReport()
      } else if(this.$store.state.report.selected_tab=='scenario') {
        this.getScenarioReport()
      }
      if (resetSort) {
        this.$store.commit("report/clearSortCol");
      }
    },
    downloadReport(){
      let report
      let reportName = this.$store.state.report.selected_tab
      switch(reportName){
        case 'popup':
          report = this.$store.state.report.popup_reports
          break;
        case 'creative':
          report = this.$store.state.report.creative_reports
          break;
        case 'new_overlay_image':
          report = this.$store.state.report.new_overlay_reports
          reportName = 'overlay'
          break;
      }
      if (report?.length == 0 ){
        return
      }
      const displayCols=this.$store.getters["report/display_col_names"];
      const header = displayCols.map((col) => this.translateName(col)).join(",");
      const rowItems = report.map((row) =>
        displayCols.map((col) => row[col]).join(","));
      const csv = [header, ...rowItems].join("\r\n");

      const blob = new Blob([csv], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", `${reportName}.csv`);
      a.click();
      a.remove();
    },
    selectWidget(name, e){
      e.preventDefault()
      this.$store.commit("report/setSelectedWidgetName", name)
      this.setTabActive('creative')
    },
    clearWidget(e){
      e.preventDefault()
      this.$store.commit("report/setSelectedWidgetName", '')
    },
    selectPopup(name, e){
      if (this.$store.state.report.selected_new_overlay_name.length > 0) {
        this.clearNewOverlay(e);
      }
      e.preventDefault()
      this.$store.commit("report/setSelectedPopupName", name)
      this.setTabActive('creative')
    },
    selectScenarioCreative(id, e){
      e.preventDefault()
      this.$store.commit("report/setSelectedCreativeId", id)
      this.setTabActive('scenario_creative')
    },
    clearPopup(e){
      e.preventDefault()
      this.$store.commit("report/setSelectedPopupName", '')
    },
    selectNewOverlay(name, e){
      if (this.$store.state.report.selected_popup_name.length > 0) {
        this.clearPopup(e);
      }
      e.preventDefault()
      this.$store.commit("report/setSelectedNewOverlayName", name)
      this.setTabActive('creative')
    },
    clearNewOverlay(e){
      e.preventDefault()
      this.$store.commit("report/setSelectedNewOverlayName", '')
    },
    selectDateFrom(date){
      const date_from = this.formatDateToBegining(date)
      const previous_date_from = this.$store.state.report.date_from
      this.$store.commit("report/setDateFrom", date_from)
      this.checkDateRange();
    },
    selectDateTo(date){
      const date_to = this.formatDateToEnd(date)
      const previous_date_to = this.$store.state.report.date_to
      this.$store.commit("report/setDateTo", date_to)
      this.checkDateRange();
    },
    checkDateRange(){
      const date_from = new Date(this.$store.state.report.date_from)
      const date_to = new Date(this.$store.state.report.date_to)
      const cutoffDate = new Date('2024/07/01 00:00:00')

      if (date_from < cutoffDate && date_to >= cutoffDate) {
        this.$toasted.error('2024年6月末までと2024年7月以降で計測方法のシステム改修をしたため、改修前後の期間をまたいだ数値の抽出はできません。')
      }
    },
    dateSelectChange(e){
      const date = e.target.value
      if(date == 'today'){
        this.$store.commit("report/setDateFrom", this.date_from)
        this.$store.commit("report/setDateTo", this.date_to)
      } else if(date == 'yesterday'){
        this.$store.commit("report/setDateFrom", this.date_yesterday_start)
        this.$store.commit("report/setDateTo", this.date_yesterday_end)
      } else if(date == 'this_month'){
        this.$store.commit("report/setDateFrom", this.date_month_start)
        this.$store.commit("report/setDateTo", this.date_to)
      } else if(date == 'last_month'){
        this.$store.commit("report/setDateFrom", this.date_last_month_start)
        this.$store.commit("report/setDateTo", this.date_last_month_end)
      }
    },
    modifyNumberFormat(col_name, data){
      if(data === undefined || data === null) {
        return '-';
      }
      const dateTo = new Date(this.$store.state.report.date_to);
      const dateFrom = new Date(this.$store.state.report.date_from);
      const cutoffDate = new Date('2024/07/01 00:00:00');

      if (col_name == "display_rate" || col_name == "display_count") {
        if (dateTo < cutoffDate || dateFrom < cutoffDate) {
          return '--';
        }
      }
      if(data == null){
        return "--"
      }

      if(col_name == "total_value"){
        return data.toLocaleString() + "円"
      } else if ( col_name == "cpm" ){
        return data.toLocaleString() + "円"
      } else if ( col_name == "imp" ){
        return data.toLocaleString()
      } else if ( col_name == "click" ){
        return data.toLocaleString()
      } else if ( col_name == "ctr" ){
        return data.toLocaleString() + "%"
      } else if ( col_name == "display_rate" ){
        return data.toLocaleString() + "%"
      } else if ( /count/.test(col_name) ){
        if(col_name == "countdown"){
          return data
        } else {
          return data.toLocaleString()
        }
      } else if ( /value/.test(col_name) ){
        return data.toLocaleString() + "円"
      } else if ( /CVR/.test(col_name) ){
        return data + "%"
      } else {
        return data
      }
    },
    async switchCreative(e, row){
      if(row["limited_time"]){
        this.$toasted.error('このクリエイティブは、表示開始・終了予約の設定がされているため、変更できません。クリエイティブ編集ページで、表示開始・終了予約の変更をしてください。')
      } else {
        await this.$store.dispatch("report/toggleCreativeDisplay", { url_token: row["url_token"] })
        if(e.value){
          this.$toasted.success('配信をONにしました')
          await sleep(10000)
          this.$toasted.clear()
        } else {
          this.$toasted.success('配信をOFFにしました')
          await sleep(10000)
          this.$toasted.clear()
        }
      }
    },
    sortAscWidgetReport(col_name){
      this.$store.commit("report/sortAscWidgetReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortDescWidgetReport(col_name){
      this.$store.commit("report/sortDescWidgetReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortAscCreativeReport(col_name){
      this.$store.commit("report/sortAscCreativeReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortDescCreativeReport(col_name){
      this.$store.commit("report/sortDescCreativeReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortAscPopUpReport(col_name){
      this.$store.commit("report/sortAscPopUpReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortDescPopUpReport(col_name){
      this.$store.commit("report/sortDescPopUpReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortAscPopupReport(col_name){
      this.$store.commit("report/sortAscPopupReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortDescPopupReport(col_name){
      this.$store.commit("report/sortDescPopupReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortAscNewOverlayReport(col_name){
      this.$store.commit("report/sortAscNewOverlayReport", col_name)
      this.getReport(false)
      return col_name
    },
    sortDescNewOverlayReport(col_name){
      this.$store.commit("report/sortDescNewOverlayReport", col_name)
      this.getReport(false)
      return col_name
    },
    ascSorted(col_name){
      return this.$store.state.report.sorted_col.name == col_name && this.$store.state.report.sorted_col.mode == "asc"
    },
    descSorted(col_name){
      return this.$store.state.report.sorted_col.name == col_name && this.$store.state.report.sorted_col.mode == "desc"
    },
    isSortable(col_name){
      return ['click', 'display_rate', 'ctr', 'cv', 'cvr', 'cpm', 'imp', 'display_count', 'total_value'].includes(col_name) ||
      col_name.startsWith('CV_') || col_name.startsWith('CVR_')
    },
    reportColHelpKey(col_name){
      if (col_name == 'widget_name' || col_name == 'pop_up_name' || col_name == 'overlay_name' || col_name == 'popup_name') {
        return 'popupReportName'
      } else if (col_name == 'imp') {
        return 'popupReportPv'
      } else if (col_name == 'display_count') {
        return 'popupReportImp'
      } else if (col_name == 'click') {
        return 'popupReportClick'
      } else if (col_name == 'display_rate') {
        return 'popupReportDisplayRate'
      } else if (col_name == 'ctr') {
        return 'popupReportCtr'
      } else if (col_name == 'cv' || col_name == 'cvr' || col_name.startsWith('CV_') || col_name.startsWith('CVR_')) {
        return 'popupReportCv'
      }
      return ''
    },
    translateName(col_name){
      if(col_name == 'widget_name' || col_name == 'pop_up_name' || col_name == 'overlay_name' || col_name == 'popup_name'){
        return "名前"
      } else if(col_name == 'popup_type'){
        return "種類"
      } else if(col_name == 'display_pattern'){
        return "表示条件"
      } else if(col_name == 'device'){
        return "デバイス"
      } else if(col_name == 'click'){
        return "クリック数"
      } else if(col_name == 'display_rate'){
        return "表示率"
      } else if(col_name == 'ctr'){
        return "クリック率"
      }else if(col_name == 'cv'){
        return "CV数"
      } else if(col_name == 'cvr'){
        return "CV率"
      } else if(col_name == 'image'){
        return "画像"
      } else if(col_name == 'title'){
        return "タイトル"
      } else if(col_name == 'animation'){
        return "アニメーション"
      } else if(col_name == 'arrow'){
        return "矢印表示"
      } else if(col_name == 'display'){
        return "表示/非表示"
      } else if(col_name == 'countdown'){
        return "カウントダウン"
      } else if(col_name == 'total_value'){
        return "CV値合計"
      } else if(col_name == 'cpm'){
        return "CPM"
      } else if(col_name == 'imp'){
        return "PV数"
      } else if(col_name == 'display_count'){
        return "表示回数"
      } else {
        return col_name;
      }
    },
    isHiddenByIframe(name, row) {
      return (name == 'click' || name == 'ctr' || /^CVR?_/.test(name)) && row['has_iframe']
    }
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("report/setSelectedTab", this.report_type)
    if (!this.is_new_ui && location.hash.replace("#", "") === 'scenario') {
      this.$store.commit("report/setSelectedTab", this.report_type)
      location.hash = this.report_type
    }
    this.$store.commit("report/setReportType", this.report_type)
    this.$store.commit("report/setDateFrom", this.date_from)
    this.$store.commit("report/setDateTo", this.date_to)
    this.$store.dispatch("report/loadCustomColNames")
    window.addEventListener('hashchange', function(e) {
      const hash_name = location.hash.replace("#", "")
      if(hash_name != ""){
        this.$store.commit("report/setSelectedTab", hash_name)
      } else {
        this.$store.commit("report/setSelectedTab", this.report_type)
      }
    }.bind(this), false);
    this.$nextTick(() => {
      this.initialized = true;
      if (this.$store.state.report.selected_tab == 'area_pop_up') {
        this.sortDescPopupReport('imp');
      } else if (this.$store.state.report.selected_tab == 'popup') {
        this.sortDescPopupReport('imp');
      } else if (this.$store.state.report.selected_tab == 'new_overlay_image') {
        this.sortDescNewOverlayReport('imp');
      } else if (this.$store.state.report.selected_tab == 'creative') {
        this.sortDescCreativeReport('imp');
      }
    });
  },
  watch: {
    '$store.state.report.selected_tab': function (val) {
      this.getReport(false)
      this.$store.dispatch("report/loadCustomColNames")
    },
    '$store.state.report.selected_cond_tab': function (val) {
      this.getReport(false)
    },
    '$store.state.report.selected_display_tab': function (val) {
      this.getReport(false)
    },
    '$store.state.report.selected_widget_name': function (val) {
      this.getCreativeReport(false)
    },
    '$store.state.report.date_from': function (val) {
      this.getReport(false)
    },
    '$store.state.report.date_to': function (val) {
      this.getReport(false)
    },
    '$store.state.report.current_page': function (val) {
      this.getReport(false)
    },
  },
  computed: {
    display_col_names(){
      return this.$store.getters["report/display_col_names"]
    },
    is_loading(){
      return this.$store.state.report.is_loading
    }
  },
  components: {
    vuejsDatepicker,
    ReportCol,
    ScenarioPopupReport
  }
}
</script>
<style lang="scss" scoped>
.tag{
  background: #f5f5f5;
  border: solid 1px #eee;
  padding: 0.2rem 0.5rem;
  font-size: 12px;
  border-radius: 0.2rem;
  .fa{
    margin-right: 0.5rem;
    cursor:pointer;
  }
}
.not-creative th:nth-child(1), .not-creative td:nth-child(1),
.not-creative th:nth-child(2), .not-creative td:nth-child(2),
.not-creative th:nth-child(3), .not-creative td:nth-child(3),
.not-creative th:nth-child(4), .not-creative td:nth-child(4) {
  width: 150px;
}
</style>
